<div
  class="flex items-center gap-3 w-full bg-black text-inverse-on-surface px-4 py-0.5 toast-shadow"
  data-testid="connection-banner"
>
  <mat-icon
    svgIcon="connection-unstable"
    class="icon-size [--icon-size:16px] shrink-0 self-start mt-0.5 text-inverse-on-surface"
  ></mat-icon>
  <p class="body-medium m-0 flex-1">{{ 'Your recording was paused due to a temporary interruption, please check your connection if interruptions continue' | translate }}</p>
</div>
